export const WARNING_BAR_TIMER = 5000
